import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { pdf } from '@react-pdf/renderer';
import { createPDF } from 'helpers/common';
import { FinancialResumeAllEstablishments, UsageResume } from '../../components/ExportPDF/templates';

import { Container, AppBar, Toolbar, Grid, IconButton, Box, Menu, MenuItem, Button, Typography, List, ListItem, Collapse, Drawer } from '@material-ui/core';
import { Menu as MenuIcon, Settings as SettingsIcon, Person, ExpandMore, Star, WhatsApp, ArrowDropUp, ArrowDropDown } from '@material-ui/icons';
import Modal from 'components/Modal';
import Loader from 'components/Loader';
import CustomButton from 'components/Button';

import { handleLogout } from '../../pages/Login/store/actions';
import { setEstablishmentId } from '../../pages/BusinessInfo/store/actions';
import { loadUsersSituation } from '../../components/Filter/store/thunk';

import { clearProduct } from 'pages/ProductsRegistration/store/actions';
import { clearProductConsumption } from 'pages/ProductsRegistration/store/actions';
import { clearProductSell } from 'pages/ProductsSellRegistration/store/actions';
import { clearProductConsumeAndSell } from 'pages/ProductsUseAndSellRegistration/store/actions';

import { setAllEstablishmentCurrentReportId } from 'pages/CashFlow/store/actions';
import { loadAllCompletedEstablishmentsFinancialAndUsageResumeReport } from 'pages/CashFlow/store/thunk';

import useWindowDimensions from '../../helpers/hooks/useWindowDimensions';
import { RESTRICTION_PAGE, SITE_RESTRICTIONS } from '../../helpers/restrictions';

import Home from '../../assets/img/icon-header-home.svg';
import Business from '../../assets/img/icon-header-business.svg';
import Operational from '../../assets/img/icon-header-operational.svg';
import Products from '../../assets/img/icon-header-products.svg';
import Financial from '../../assets/img/icon-header-financial.svg';
import Clients from '../../assets/img/icon-header-clients.svg';
import Settings from '../../assets/img/icon-header-settings.svg';
import Profile from '../../assets/img/icon-header-profile.svg';
import Logout from '../../assets/img/icon-header-logout.svg';

import { useStyles } from './styles';

import projectPackage from '../../../package.json';

const logo = require('../../assets/img/logo_header.svg');

const Header = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const windowSize = useWindowDimensions();
  const positionDropdownMenu = windowSize.width > 960 ? 'center' : 'left';
  const isSm = windowSize.width < 900;

  const isResale = !!process.env.REACT_APP_RESALE_ID;

  const { userId, resaleId } = useSelector(state => state.profile);
  const { establishmentId, previousEstablishmentId } = useSelector(state => state.businessInfo);
  const { token } = useSelector(state => state.login);
  const { profileId, isAdminUser, name, email, phone } = useSelector(state => state.profile.submit);
  const employeeMainUser = useSelector(state => state.employeesRegistration.mainUser);
  const { allEstablishmentCurrentReportId, allEstablishmentToastId } = useSelector(state => state.cashFlow);
  const userRestrictions = useSelector(state => state.profile.userRestrictions);
  const situationEstablishments = useSelector(state => state.login.situation.establishments);
  const situationSuperlogica = useSelector(state => state.login.situation.superlogica);

  const { allEstablishments } = useSelector(state => state.login);

  const servicesCategories = useSelector(state => state.filters)
    ?.selects
    ?.find(filter => filter?.id == 'serviceCategory')
    ?.options;

  const [defaultEstablishmentTypes, setDefaultEstablishmentTypes] = useState([]);
  const [isDebitWarningModalOpen, setIsDebitWarningModalOpen] = useState(false);
  const [isLoginFromNoAccessCode] = useState(!!history.location.state?.data?.noAccessCode);

  const [menuItemClicked, setMenuItemClicked] = useState('');
  const [isTooltipModalOpen, setIsTooltipModalOpen] = useState(false);

  const usersEstablishments = situationEstablishments;
  const superLogica = situationSuperlogica;
  const isUserAdmin = +isAdminUser == 1;

  const premiumPackageEstablishments = usersEstablishments
    ?.filter(establishment => +establishment?.premiumPackage == 1)
    ?.map(establishment => establishment?.establishmentId);

  const debitWarningEstablishments = usersEstablishments
    ?.filter(establishment => +establishment?.appPermission == 1)
    ?.filter(establishment => +establishment?.debitWarning == 1);

  const isPremiumPackage = premiumPackageEstablishments?.includes(establishmentId) || isUserAdmin;
  const isDebitWarning = debitWarningEstablishments?.length > 0;

  const isAll = !establishmentId;
  const isParkingBasic = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 1 && !isPremiumPackage;
  const isParkingPremium = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 1 && isPremiumPackage;
  const isParkingBasicAndPremium = defaultEstablishmentTypes.includes(1);
  const isCarWashBasic = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 2 && !isPremiumPackage;
  const isCarWashPremium = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 2 && isPremiumPackage;
  const isStoreBasicAndPremium = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 3;
  const isParkingAndCarWashBasic = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(2) && !isPremiumPackage;
  const isParkingAndCarWashPremium = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(2) && isPremiumPackage;
  const isCarWashAndStoreBasic = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(2) && defaultEstablishmentTypes.includes(3) && !isPremiumPackage;
  const isCarWashAndStorePremium = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(2) && defaultEstablishmentTypes.includes(3) && isPremiumPackage;
  const isParkingAndStoreBasic = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(3) && !isPremiumPackage;
  const isParkingAndStorePremium = defaultEstablishmentTypes.length == 2 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(3) && isPremiumPackage;
  const isParkingAndCarWashAndStoreBasic = defaultEstablishmentTypes.length == 3 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(2) && defaultEstablishmentTypes.includes(3);
  const isParkingAndCarWashAndStorePremium = defaultEstablishmentTypes.length == 3 && defaultEstablishmentTypes.includes(1) && defaultEstablishmentTypes.includes(2) && defaultEstablishmentTypes.includes(3) && isPremiumPackage;

  const isStore = defaultEstablishmentTypes.includes(3);
  const isStoreOnly = defaultEstablishmentTypes.length == 1 && +defaultEstablishmentTypes[0] == 3;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if(!isUserAdmin) {
      setIsDebitWarningModalOpen(isDebitWarning);
    }
  }, [isDebitWarning, history.location.pathname]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const interval = setInterval(() => {
      if(userId && !isLoginFromNoAccessCode) {
        dispatch(loadUsersSituation(userId, token));
      }
    }, 600000);

    return () => clearInterval(interval);
  }, [isLoginFromNoAccessCode]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const establishmentTypes = usersEstablishments
      ?.find(establishment => +establishment?.establishmentId == +establishmentId)
      ?.establishmentTypes
      ?.map(establishmentTypes => +establishmentTypes) || [];

    setDefaultEstablishmentTypes(establishmentTypes);
  }, [usersEstablishments, establishmentId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if(history.location.pathname != '/visao-geral') {
      if(previousEstablishmentId) {
        dispatch(setEstablishmentId({ establishmentId: previousEstablishmentId }));
      }
    }
  }, [previousEstablishmentId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if(allEstablishmentCurrentReportId) {
      const interval = setInterval(() => {
        dispatch(loadAllCompletedEstablishmentsFinancialAndUsageResumeReport(userId, allEstablishmentCurrentReportId)).then(data => {
          toast.dismiss(allEstablishmentToastId);
          dispatch(setAllEstablishmentCurrentReportId(''));

          const { description, report, reportTypeId } = data;

          if(+reportTypeId == 1) {
            const formmatedData = Object.keys(report).map(establishmentId => {
              return {
                ...report[establishmentId],
                establishmentId
              };
            });

            let component = pdf(
              <FinancialResumeAllEstablishments
                exportData={formmatedData}
                period={description}
                servicesCategories={servicesCategories}
                allEstablishments={allEstablishments}
              />
            );

            return createPDF(component);
          }

          if(+reportTypeId == 2) {
            const allEstablishmentsData = Object
              .keys(report)
              .filter(key => report[key]?.data?.length > 0)
              .map(key => report[key]?.data)
              .flat();

            let component = pdf(
              <UsageResume
                exportData={allEstablishmentsData}
                establishmentName='Todos os estabelecimentos'
                fileName={description}
                dateRange={['', '']}
              />
            );

            return createPDF(component);
          }
        });
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [allEstablishmentCurrentReportId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [currentOpenMobileMenu, setCurrentOpenMobileMenu] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorBusinessEl, setAnchorBusinessEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorOperationalEl, setAnchorOperationalEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorProductsEl, setAnchorProductsEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorFinantialEl, setAnchorFinantialEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorClientsEl, setAnchorClientsEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorConfigurationEl, setAnchorConfigurationEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [anchorProfileEl, setAnchorProfileEl] = React.useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const businessMenuId = {
    desktop: 'business-menu-item',
    mobile: 'business-menu-mobile',
    menu: 'business-menu',
    isMenuOpen: Boolean(anchorBusinessEl)
  }

  const operationalMenuId = {
    desktop: 'operational-menu-item',
    mobile: 'operational-menu-mobile',
    menu: 'operational-menu',
    isMenuOpen: Boolean(anchorOperationalEl)
  }

  const productsMenuId = {
    desktop: 'products-menu-item',
    mobile: 'products-menu-mobile',
    menu: 'products-menu',
    isMenuOpen: Boolean(anchorProductsEl)
  }

  const finantialMenuId = {
    desktop: 'finantial-menu-item',
    mobile: 'finantial-menu-mobile',
    menu: 'finantial-menu',
    isMenuOpen: Boolean(anchorFinantialEl),
  }

  const clientsMenuId = {
    desktop: 'clients-menu-item',
    mobile: 'clients-menu-mobile',
    menu: 'clients-menu',
    isMenuOpen: Boolean(anchorClientsEl)
  }

  const configurationsMenuId = {
    desktop: 'configuration-menu-item',
    mobile: 'configuration-menu-mobile',
    menu: 'configuration-menu',
    isMenuOpen: Boolean(anchorConfigurationEl)
  }

  const profileMenuId = {
    desktop: 'profile-menu-item',
    mobile: 'profile-menu-mobile',
    menu: 'profile-menu',
    isMenuOpen: Boolean(anchorProfileEl)
  }

  const handleProductButtonLink = () => {
    if(isStoreOnly) {
      return '/novo-produto-venda';
    }

    if(isStore) {
      return '/objetivo-do-produto';
    }

    return '/novo-produto';
  }

  const getPremiumPackageVideo = () => {
    if(menuItemClicked == '/produtos' || menuItemClicked == '/produtos-consumo' || menuItemClicked == '/produtos-venda') {
      return 'https://www.youtube.com/embed/ow0Becv_dGc?autoplay=1&mute=0';
    }

    if(menuItemClicked == '/funcionarios') {
      return 'https://www.youtube.com/embed/vuftq8Dp_1g?autoplay=1&mute=0';
    }

    if(menuItemClicked == '/comissionamento') {
      return 'https://www.youtube.com/embed/4ZuSFP7NBrI?autoplay=1&mute=0';
    }

    if(menuItemClicked == '/agendamento') {
      return 'https://www.youtube.com/embed/T1lEn8aIgn0?autoplay=1&mute=0';
    }

    if(menuItemClicked == '/api-aberta') {
      return 'https://www.youtube.com/embed/B6d3NiE-Kes?autoplay=1&mute=0';
    }

    if(menuItemClicked == '/notas-fiscais' || menuItemClicked == '/configuracoes-de-notas-fiscais' || menuItemClicked == '/configuracoes-de-notas-fiscais/informacoes-basicas') {
      return 'https://www.youtube.com/embed/KwT-TmgHhrU?autoplay=1&mute=0';
    }
  }

  const userHasAllRestrictions = () => {
    return (
      userRestrictions?.includes(RESTRICTION_PAGE.CREATE_ESTABLISHMENT) &&
      userRestrictions?.includes(RESTRICTION_PAGE.CREATE_USER)
    );
  }

  const handleOpenMenu = event => {
    switch (event.currentTarget.id) {
      case businessMenuId.desktop:
        setAnchorBusinessEl(event.currentTarget);
        break;
      case operationalMenuId.desktop:
        setAnchorOperationalEl(event.currentTarget);
        break;
      case productsMenuId.desktop:
        setAnchorProductsEl(event.currentTarget);
        break;
      case finantialMenuId.desktop:
        setAnchorFinantialEl(event.currentTarget);
        break;
      case clientsMenuId.desktop:
        setAnchorClientsEl(event.currentTarget);
        break;
      case configurationsMenuId.desktop:
        setAnchorConfigurationEl(event.currentTarget);
        break;
      case profileMenuId.desktop:
        setAnchorProfileEl(event.currentTarget);
        break;
      default:
        break;
    }
  }

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  const handleMenuClose = () => {
    setAnchorBusinessEl(null);
    setAnchorOperationalEl(null);
    setAnchorProductsEl(null);
    setAnchorFinantialEl(null);
    setAnchorClientsEl(null);
    setAnchorConfigurationEl(null);
    setAnchorProfileEl(null);
  }

  const handleSendMessage = () => {
    const message = `Usuário: ${name} %0aEmail: ${email} %0aTelefone: ${phone} %0aEstabelecimento: ${establishmentId} %0a%0aTenho interesse no Pacote Premium!`;
    const whatsAppMessage = `https://wa.me/+5521999966453/?text=${message}`;

	  window.open(whatsAppMessage, '_blank').focus();
  }

  const getConsumeProductLink = () => {
    if(isPremiumPackage && isParkingAndCarWashAndStoreBasic) {
      return '/produtos-consumo';
    }

    return isPremiumPackage ? '/produtos-consumo' : location.pathname;
  }

  const getSellProductLink = () => {
    if(!isPremiumPackage) {
      if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
        return '/produtos-venda';
      }
    }

    if(isPremiumPackage && isParkingAndCarWashAndStoreBasic) {
      return '/produtos-venda';
    }

    return isPremiumPackage ? '/produtos-venda' : location.pathname;
  }

  const getSuppliersLink = () => {
    if(!isPremiumPackage) {
      if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
        return '/fornecedores';
      }
    }

    return isPremiumPackage ? '/fornecedores' : location.pathname;
  }

  const getProductMenuWidth = () => {
    if(isUserAdmin) {
      return 600;
    }

    if(isCarWashPremium) {
      return 450;
    }

    if(isParkingAndCarWashPremium) {
      return 500;
    }

    return 600;
  }

  const logout = () => {
    dispatch(handleLogout());
  }

  const renderBusinessMenu = (
    <Menu
      keepMounted
      anchorEl={anchorBusinessEl}
      id={businessMenuId.menu}
      open={businessMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      className={classes.menuListSectionsContent}
      MenuListProps={{ disablePadding: true }}
    >
      <Grid container>
        <Grid item xs={12} md={!userHasAllRestrictions() ? 6 : 12}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Controle e Listagem
          </Typography>
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/estabelecimento"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Estabelecimento
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/usuarios"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Usuários
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/tabelas-de-preco"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Tabela de estacionamento
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/servicos"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Tabela de serviço
            </MenuItem>
          )}
          {(isUserAdmin || isCarWashBasic || isParkingAndCarWashBasic) && (
            <MenuItem
              to={getConsumeProductLink()}
              component={Link}
              onClick={() => {
                if(location.pathname == '/produtos-consumo') {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                  return;
                }

                dispatch(clearProduct());
                dispatch(clearProductConsumption());
                dispatch(clearProductSell());
                dispatch(clearProductConsumeAndSell());

                if(!isPremiumPackage) {
                  setMenuItemClicked('/produtos-consumo');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Produto para consumo</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Produto para consumo
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
          {isParkingBasicAndPremium && (
            <MenuItem
              to="/autoatendimento"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Totens (Autoatendimento)
            </MenuItem>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Relatórios ou Controle
          </Typography>
          {(isUserAdmin || isAll) && (
            <MenuItem
              to="/novo-usuario"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Novo usuário
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/registro-de-atividades"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Registro de Atividades
            </MenuItem>
          )}
          {!!(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/registro-de-sessoes"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Registro de Sessões
            </MenuItem>
          )}
        </Grid>
      </Grid>
    </Menu>
  );

  const renderOperacionalMenu = (
    <Menu
      keepMounted
      anchorEl={anchorOperationalEl}
      id={operationalMenuId.menu}
      open={operationalMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      className={classes.menuListContent}
      MenuListProps={{ disablePadding: true }}
    >
      <Grid container>
        <Grid item xs={12} md={!!(isUserAdmin || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) ? 6 : 12}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Relatórios ou Controle
          </Typography>
          {!!(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/historico-operacional"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Histórico Operacional
            </MenuItem>
          )}
          {!!(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/historico-de-avarias"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Dossiê de Avarias
            </MenuItem>
          )}
        </Grid>
        {(isUserAdmin || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              color="primary"
              component="h6"
              className={classes.subMenuTitle}
            >
              Cadastro ou Listagem
            </Typography>
            {!!(isUserAdmin || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
              <MenuItem
                to={getConsumeProductLink()}
                component={Link}
                onClick={() => {
                  if(location.pathname == '/produtos-consumo') {
                    handleMenuClose();
                    setMobileMenuOpen(false);
                    return;
                  }

                  dispatch(clearProduct());
                  dispatch(clearProductConsumption());
                  dispatch(clearProductSell());
                  dispatch(clearProductConsumeAndSell());

                  if(!isPremiumPackage) {
                    setMenuItemClicked('/produtos-consumo');
                    setIsTooltipModalOpen(true);
                  }

                  handleMenuClose();
                  setMobileMenuOpen(false);
                }}
              >
                {isPremiumPackage ? (
                  <>Produto para consumo</>
                ) : (
                  <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                    Produto para consumo
                    <Typography style={{ color: "#F5B941" }}>
                      <Star style={{ verticalAlign: 'sub' }} />
                    </Typography>
                  </div>
                )}
              </MenuItem>
            )}
            {!!(isUserAdmin || isParkingAndCarWashAndStoreBasic || isParkingAndCarWashAndStorePremium || isCarWashAndStoreBasic || isCarWashAndStorePremium) && (
              <MenuItem
                to={isPremiumPackage ? '/configuracoes-de-notas-fiscais' : location.pathname}
                onClick={() => {
                  if(!isPremiumPackage) {
                    setMenuItemClicked('/configuracoes-de-notas-fiscais');
                    setIsTooltipModalOpen(true);
                  }

                  handleMenuClose();
                  setMobileMenuOpen(false);
                }}
                component={Link}
              >
                {isPremiumPackage ? (
                  <>NFS-e</>
                ) : (
                  <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                    NFS-e
                    <Typography style={{ color: "#F5B941" }}>
                      <Star style={{ verticalAlign: 'sub' }} />
                    </Typography>
                  </div>
                )}
              </MenuItem>
            )}
          </Grid>
        )}
      </Grid>
    </Menu>
  );

  const renderProductsMenu = (
    <Menu
      keepMounted
      anchorEl={anchorProductsEl}
      id={productsMenuId.menu}
      open={productsMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      MenuListProps={{ disablePadding: true }}
    >
      <Grid container style={{ width: getProductMenuWidth() }}>
        <Grid item xs={12} md={(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) ? 4 : 6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Cadastro ou Listagem
          </Typography>
          {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to={getSellProductLink()}
              component={Link}
              onClick={() => {
                if(location.pathname == '/produtos-venda') {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                  return;
                }

                dispatch(clearProduct());
                dispatch(clearProductConsumption());
                dispatch(clearProductSell());
                dispatch(clearProductConsumeAndSell());

                if(!isPremiumPackage) {
                  if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
                    handleMenuClose();
                    setMobileMenuOpen(false);
                    return;
                  }

                  setMenuItemClicked('/produtos-venda');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {(isStoreOnly && !isPremiumPackage) ? (
                <>{isStoreOnly ? 'Estoque e cadastro' : 'Produto para venda'}</>
              ) : (
                <>
                  {(isPremiumPackage || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) ? (
                    <>Estoque e cadastro</>
                  ) : (
                    <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                      Estoque e cadastro
                      <Typography style={{ color: "#F5B941" }}>
                        <Star style={{ verticalAlign: 'sub' }} />
                      </Typography>
                    </div>
                  )}
                </>
              )}
            </MenuItem>
          )}
          {(isCarWashPremium || isParkingAndCarWashPremium) && (
            <MenuItem
              to={getConsumeProductLink()}
              component={Link}
              onClick={() => {
                if(location.pathname == '/produtos-consumo') {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                  return;
                }

                dispatch(clearProduct());
                dispatch(clearProductConsumption());
                dispatch(clearProductSell());
                dispatch(clearProductConsumeAndSell());

                if(!isPremiumPackage) {
                  setMenuItemClicked('/produtos-consumo');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Produto para consumo</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Produto para consumo
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
          {(isUserAdmin || isAll) && (
            <MenuItem
              to={isPremiumPackage ? "/produtos" : location.pathname}
              component={Link}
              onClick={() => {
                if(!isPremiumPackage) {
                  setMenuItemClicked('/produtos');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Listagem de produto</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Listagem de produto
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
        </Grid>
        {!!(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              color="primary"
              component="h6"
              className={classes.subMenuTitle}
            >
              Relatórios ou Controle
            </Typography>
            {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
              <MenuItem
                to="/historico-de-venda"
                onClick={() => {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                }}
                component={Link}
              >
                Histórico de Pedidos
              </MenuItem>
            )}
          </Grid>
        )}
        <Grid item xs={12} md={(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) ? 4 : 6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Cadastro e Configuração
          </Typography>
          {!!(isUserAdmin || isAll) && (
            <MenuItem
              to={isPremiumPackage ? handleProductButtonLink : location.pathname}
              component={Link}
              onClick={() => {
                if(location.pathname == handleProductButtonLink()) {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                  return;
                }

                dispatch(clearProduct());
                dispatch(clearProductConsumption());
                dispatch(clearProductSell());
                dispatch(clearProductConsumeAndSell());

                if(!isPremiumPackage) {
                  setMenuItemClicked('/produtos');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Cadastrar produto</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Cadastrar produto
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
          {(isUserAdmin || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/marcas-de-produtos"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Marcas
            </MenuItem>
          )}
          {!!(isUserAdmin || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/categorias-de-produtos"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Categorias
            </MenuItem>
          )}
          <MenuItem
            to={getSuppliersLink()}
            component={Link}
            onClick={() => {
              if(!isPremiumPackage) {
                if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
                  handleMenuClose();
                  setMobileMenuOpen(false);
                  return;
                }

                setMenuItemClicked('/fornecedores');
                setIsTooltipModalOpen(true);
              }

              handleMenuClose();
              setMobileMenuOpen(false);
            }}
          >
            {(isStoreOnly && !isPremiumPackage) ? (
              <>Fornecedores</>
            ) : (
              <>
                {(isPremiumPackage || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) ? (
                  <>Fornecedores</>
                ) : (
                  <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                    Fornecedores
                    <Typography style={{ color: "#F5B941" }}>
                      <Star style={{ verticalAlign: 'sub' }} />
                    </Typography>
                  </div>
                )}
              </>
            )}
          </MenuItem>
          {!!(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/notas-fiscais"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              NFe e NFC
            </MenuItem>
          )}
        </Grid>
      </Grid>
    </Menu>
  );

  const renderFinantialMenu = (
    <Menu
      keepMounted
      anchorEl={anchorFinantialEl}
      id={finantialMenuId.menu}
      open={finantialMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      className={classes.menuListContent}
      MenuListProps={{ disablePadding: true }}
    >
      <Grid container style={{ width: 400 }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Cadastro e/ou Listagem
          </Typography>
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/transacoes"
              onClick={() => {
                handleMenuClose()
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Transações
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to={isPremiumPackage ? "/funcionarios" : location.pathname}
              component={Link}
              onClick={() => {
                if(!isPremiumPackage) {
                  setMenuItemClicked('/funcionarios');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Folha de pagamento</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Folha de pagamento
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
          {!!(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to={isPremiumPackage ? "/comissionamento" : location.pathname}
              component={Link}
              onClick={() => {
                if(!isPremiumPackage) {
                  setMenuItemClicked('/comissionamento');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
            >
              {isPremiumPackage ? (
                <>Comissionamento</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  Comissionamento
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Relatórios ou Controle
          </Typography>
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
            <MenuItem
              to="/fluxo-de-caixa"
              onClick={() => {
                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Fluxo de caixa
            </MenuItem>
          )}
          {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic) && (
            <MenuItem
              to={isPremiumPackage ? '/notas-fiscais' : location.pathname}
              onClick={() => {
                if(!isPremiumPackage) {
                  setMenuItemClicked('/notas-fiscais');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              {isPremiumPackage ? (
                <>NFS-e</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  NFS-e
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
        </Grid>
      </Grid>
    </Menu>
  );

  const renderClientsMenu = (
    <Menu
      keepMounted
      anchorEl={anchorClientsEl}
      id={clientsMenuId.menu}
      open={clientsMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      MenuListProps={{ disablePadding: true }}
    >
      <Typography
        variant="h6"
        color="primary"
        component="h6"
        className={classes.subMenuTitle}
      >
        Cadastro e Listagem
      </Typography>
      {!!(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
        <MenuItem
          to="/clientes"
          onClick={() => {
            handleMenuClose();
            setMobileMenuOpen(false);
          }}
          component={Link}
        >
          Clientes
        </MenuItem>
      )}
      {(isUserAdmin || isAll) && (
        <MenuItem
          to="/clientes?newClient=true"
          onClick={() => {
            handleMenuClose();
            setMobileMenuOpen(false);
          }}
          component={Link}
        >
          Novo Cliente
        </MenuItem>
      )}
      {!!(isUserAdmin || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
        <MenuItem
          to="/lembrete-pos-venda"
          onClick={() => {
            handleMenuClose();
            setMobileMenuOpen(false);
          }}
          component={Link}
        >
          Lembrete Pós Venda
        </MenuItem>
      )}
      {!!(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
        <MenuItem
          to={isPremiumPackage ? '/agendamento' : location.pathname}
          component={Link}
          onClick={() => {
            if(!isPremiumPackage) {
              setMenuItemClicked('/agendamento');
              setIsTooltipModalOpen(true);
            }

            handleMenuClose();
            setMobileMenuOpen(false);
          }}
        >
          {isPremiumPackage ? (
            <>Agendamento</>
          ) : (
            <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
              Agendamento
              <Typography style={{ color: "#F5B941" }}>
                <Star style={{ verticalAlign: 'sub' }} />
              </Typography>
            </div>
          )}
        </MenuItem>
      )}
    </Menu>
  );

  const renderConfigurationMenu = (
    <Menu
      keepMounted
      anchorEl={anchorConfigurationEl}
      id={configurationsMenuId.menu}
      open={configurationsMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      getContentAnchorEl={null}
      className={classes.menuListSectionsContent}
      MenuListProps={{ disablePadding: true }}
    >
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Operacionais
          </Typography>
          <MenuItem
            to="/comprovantes"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Comprovantes
          </MenuItem>
          <MenuItem
            to="/operacao"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Operação
          </MenuItem>
          <MenuItem
            to="/caixa"
            onClick={() => {
              handleMenuClose()
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Caixa
          </MenuItem>
          {(isUserAdmin || (+profileId == 2 && +employeeMainUser == 1)) && (
            <MenuItem
              to="/configuracoes-avancadas"
              onClick={() => {
                handleMenuClose()
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              Avançadas
            </MenuItem>
          )}
          <MenuItem
            to={isPremiumPackage ? '/api-aberta' : location.pathname}
            component={Link}
            onClick={() => {
              if(location.pathname == '/api-aberta') {
                handleMenuClose();
                setMobileMenuOpen(false);
                return;
              }

              if(!isPremiumPackage) {
                setMenuItemClicked('/api-aberta');
                setIsTooltipModalOpen(true);
              }

              handleMenuClose();
              setMobileMenuOpen(false);
            }}
          >
            {isPremiumPackage ? (
              <>API Aberta</>
            ) : (
              <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                API Aberta
                <Typography style={{ color: "#F5B941" }}>
                  <Star style={{ verticalAlign: 'sub' }} />
                </Typography>
              </div>
            )}
          </MenuItem>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h6"
            color="primary"
            component="h6"
            className={classes.subMenuTitle}
          >
            Financeiras
          </Typography>
          <MenuItem
            to="/contas"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Contas
          </MenuItem>
          <MenuItem
            to="/meios-de-pagamento"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Meios de pagamento
          </MenuItem>
          <MenuItem
            to="/categorias"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Categorias
          </MenuItem>
          <MenuItem
            to="/centros-de-custo"
            onClick={() => {
              handleMenuClose();
              setMobileMenuOpen(false);
            }}
            component={Link}
          >
            Centros de custo
          </MenuItem>
          {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic) && (
            <MenuItem
              to={isPremiumPackage ? '/configuracoes-de-notas-fiscais' : location.pathname}
              onClick={() => {
                if(!isPremiumPackage) {
                  setMenuItemClicked('/configuracoes-de-notas-fiscais');
                  setIsTooltipModalOpen(true);
                }

                handleMenuClose();
                setMobileMenuOpen(false);
              }}
              component={Link}
            >
              {isPremiumPackage ? (
                <>NFS-e</>
              ) : (
                <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                  NFS-e
                  <Typography style={{ color: "#F5B941" }}>
                    <Star style={{ verticalAlign: 'sub' }} />
                  </Typography>
                </div>
              )}
            </MenuItem>
          )}
        </Grid>
      </Grid>
    </Menu>
  );

  const renderProfileMenu = (
    <Menu
      keepMounted
      anchorEl={anchorProfileEl}
      id={profileMenuId.menu}
      open={profileMenuId.isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: positionDropdownMenu }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      getContentAnchorEl={null}
      className={classes.menuListContent}
      MenuListProps={{ minWidth: '180px' }}
    >
      <MenuItem
        to="/perfil"
        onClick={() => {
          handleMenuClose();
          setMobileMenuOpen(false);
        }}
        component={Link}
      >
        Perfil
      </MenuItem>
      <MenuItem
        to="/"
        onClick={logout}
        component={Link}
      >
        Sair
      </MenuItem>
      <MenuItem className={classes.versionItem}>
        <Typography variant="subtitle1" component="subtitle1">
          Versão {projectPackage.version}
        </Typography>
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Drawer
      id='header-mobile-menu'
      anchor='left'
      open={mobileMenuOpen}
      onClose={() => setMobileMenuOpen(!mobileMenuOpen)}
      PaperProps={{
        style: {
          width: isSm ? '70%' : '50%'
        }
      }}
    >
      <Box pt={2} padding={2} display='flex' flexDirection='column' justifyContent='space-between' height='100%'>
        <List component="div">
          {(isUserAdmin || !isLoginFromNoAccessCode) && (
            <ListItem
              button
              className={classes.menuMobileItem}
              to="/visao-geral"
              component={Link}
              onClick={handleOpenMenu}
            >
              <div className={classes.menuMobileText}>
                <img src={Home} width='20' height='20' />
                <Typography color='primary' className={classes.menuMobileTextTypography}>
                  Visão geral
                </Typography>
              </div>
            </ListItem>
          )}
          {(isUserAdmin || !isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.BUSINESS)) && (
            <>
              <ListItem
                button
                className={(businessMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                onClick={() => {
                  if(businessMenuId.mobile == currentOpenMobileMenu) {
                    return setCurrentOpenMobileMenu(null);
                  }

                  setCurrentOpenMobileMenu(businessMenuId.mobile);
                }}
                id={businessMenuId.mobile}
              >
                <div className={classes.menuMobileText}>
                  <img src={Business} width='20' height='20' />
                  <Typography color='primary' className={classes.menuMobileTextTypography}>
                    Negócio
                  </Typography>
                </div>
                {(businessMenuId.mobile == currentOpenMobileMenu) ? (
                  <ArrowDropUp style={{ color: '#022A5C' }} />
                ) : (
                  <ArrowDropDown style={{ color: '#022A5C' }} />
                )}
              </ListItem>
              <Collapse in={businessMenuId.mobile == currentOpenMobileMenu}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Controle e Listagem</b>
                  </Typography>
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/estabelecimento'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Estabelecimento
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/usuarios'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Usuários
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/tabelas-de-preco'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Tabela de estacionamento
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/servicos'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Tabela de serviço
                    </Typography>
                  )}
                  {(isUserAdmin || isCarWashBasic || isParkingAndCarWashBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/produtos-consumo' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/produtos-consumo');
                          setIsTooltipModalOpen(true);
                        }

                        dispatch(clearProduct());
                        dispatch(clearProductConsumption());
                        dispatch(clearProductSell());
                        dispatch(clearProductConsumeAndSell());

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>Produto para consumo</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          Produto para consumo
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                  {isParkingBasicAndPremium && (
                    <Typography
                      to='/autoatendimento'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Totens (Autoatendimento)
                    </Typography>
                  )}
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Relatórios ou Controle</b>
                  </Typography>
                  {(isUserAdmin || isAll) && (
                    <Typography
                      to='/novo-usuario'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Novo usuário
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/registro-de-atividades'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Registro de Atividades
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/registro-de-sessoes'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Registro de Sessões
                    </Typography>
                  )}
                </div>
              </Collapse>
            </>
          )}
          {(isUserAdmin || !isLoginFromNoAccessCode) && (
            <>
              {!!(isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                <>
                  <ListItem
                    button
                    className={(operationalMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                    onClick={() => {
                      if(operationalMenuId.mobile == currentOpenMobileMenu) {
                        return setCurrentOpenMobileMenu(null);
                      }

                      setCurrentOpenMobileMenu(operationalMenuId.mobile);
                    }}
                    id={operationalMenuId.mobile}
                  >
                    <div className={classes.menuMobileText}>
                      <img src={Operational} width='20' height='20' />
                      <Typography color='primary' className={classes.menuMobileTextTypography}>
                        {(isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) ? 'Serviços' : 'Operacional'}
                      </Typography>
                    </div>
                    {(operationalMenuId.mobile == currentOpenMobileMenu) ? (
                      <ArrowDropUp style={{ color: '#022A5C' }} />
                    ) : (
                      <ArrowDropDown style={{ color: '#022A5C' }} />
                    )}
                  </ListItem>
                  <Collapse in={operationalMenuId.mobile == currentOpenMobileMenu}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                      <Typography className={classes.menuMobileSubTextTypography}>
                        <b>Relatórios ou Controle</b>
                      </Typography>
                      {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to='/historico-operacional'
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          Histórico Operacional
                        </Typography>
                      )}
                      {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to='/historico-de-avarias'
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          Dossiê de Avarias
                        </Typography>
                      )}
                      {(isUserAdmin || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <>
                          <Typography className={classes.menuMobileSubTextTypography}>
                            <b>Cadastro ou Listagem</b>
                          </Typography>
                          {!!(isUserAdmin || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                            <Typography
                              to={isPremiumPackage ? '/produtos-consumo' : location.pathname}
                              component={Link}
                              className={classes.menuMobileTypography}
                              onClick={() => {
                                if(!isPremiumPackage) {
                                  setMenuItemClicked('/produtos-consumo');
                                  setIsTooltipModalOpen(true);
                                }

                                dispatch(clearProduct());
                                dispatch(clearProductConsumption());
                                dispatch(clearProductSell());
                                dispatch(clearProductConsumeAndSell());

                                setMobileMenuOpen(!mobileMenuOpen);
                                setCurrentOpenMobileMenu(null);
                              }}
                            >
                              {isPremiumPackage ? (
                                <>Produto para consumo</>
                              ) : (
                                <div style={{ display: 'flex', gap: 5 }}>
                                  Produto para consumo
                                  <Typography style={{ color: "#F5B941" }}>
                                    <Star />
                                  </Typography>
                                </div>
                              )}
                            </Typography>
                          )}
                          {(isUserAdmin || isParkingAndCarWashAndStoreBasic || isParkingAndCarWashAndStorePremium || isCarWashAndStoreBasic || isCarWashAndStorePremium) && (
                            <Typography
                              to={isPremiumPackage ? '/configuracoes-de-notas-fiscais' : location.pathname}
                              component={Link}
                              className={classes.menuMobileTypography}
                              onClick={() => {
                                if(!isPremiumPackage) {
                                  setMenuItemClicked('/configuracoes-de-notas-fiscais');
                                  setIsTooltipModalOpen(true);
                                }

                                setMobileMenuOpen(!mobileMenuOpen);
                                setCurrentOpenMobileMenu(null);
                              }}
                            >
                              {isPremiumPackage ? (
                                <>NFS-e</>
                              ) : (
                                <div style={{ display: 'flex', gap: 5 }}>
                                  NFS-e
                                  <Typography style={{ color: "#F5B941" }}>
                                    <Star />
                                  </Typography>
                                </div>
                              )}
                            </Typography>
                          )}
                        </>
                      )}
                    </div>
                  </Collapse>
                </>
              )}
            </>
          )}
          {(isUserAdmin || !isLoginFromNoAccessCode) && (
            <>
              {!!(isAll || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                <>
                  <ListItem
                    button
                    className={(productsMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                    onClick={() => {
                      if(productsMenuId.mobile == currentOpenMobileMenu) {
                        return setCurrentOpenMobileMenu(null);
                      }

                      setCurrentOpenMobileMenu(productsMenuId.mobile);
                    }}
                    id={productsMenuId.mobile}
                  >
                    <div className={classes.menuMobileText}>
                      <img src={Products} width='20' height='20' />
                      <Typography color='primary' className={classes.menuMobileTextTypography}>
                        Produtos
                      </Typography>
                    </div>
                    {(productsMenuId.mobile == currentOpenMobileMenu) ? (
                      <ArrowDropUp style={{ color: '#022A5C' }} />
                    ) : (
                      <ArrowDropDown style={{ color: '#022A5C' }} />
                    )}
                  </ListItem>
                  <Collapse in={productsMenuId.mobile == currentOpenMobileMenu}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                      <Typography className={classes.menuMobileSubTextTypography}>
                        <b>Cadastro ou Listagem</b>
                      </Typography>
                      {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to={getSellProductLink()}
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            dispatch(clearProduct());
                            dispatch(clearProductConsumption());
                            dispatch(clearProductSell());
                            dispatch(clearProductConsumeAndSell());

                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);

                            if(!isPremiumPackage) {
                              if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
                                return;
                              }

                              setMenuItemClicked('/produtos-venda');
                              setIsTooltipModalOpen(true);
                            }
                          }}
                        >
                          {(isStoreOnly && !isPremiumPackage) ? (
                            <>{isStoreOnly ? 'Estoque e cadastro' : 'Produto para venda'}</>
                          ) : (
                            <>
                              {(isPremiumPackage || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) ? (
                                <>Estoque e cadastro</>
                              ) : (
                                <div style={{ display: 'flex', gap: 5 }}>
                                  Estoque e cadastro
                                  <Typography style={{ color: "#F5B941" }}>
                                    <Star />
                                  </Typography>
                                </div>
                              )}
                            </>
                          )}
                        </Typography>
                      )}
                      {(isUserAdmin || isCarWashPremium || isParkingAndCarWashPremium) && (
                        <Typography
                          to={isPremiumPackage ? '/produtos-consumo' : location.pathname}
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            if(!isPremiumPackage) {
                              setMenuItemClicked('/produtos-consumo');
                              setIsTooltipModalOpen(true);
                            }

                            dispatch(clearProduct());
                            dispatch(clearProductConsumption());
                            dispatch(clearProductSell());
                            dispatch(clearProductConsumeAndSell());

                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          {isPremiumPackage ? (
                            <>Produto para consumo</>
                          ) : (
                            <div style={{ display: 'flex', gap: 5 }}>
                              Produto para consumo
                              <Typography style={{ color: "#F5B941" }}>
                                <Star />
                              </Typography>
                            </div>
                          )}
                        </Typography>
                      )}
                      {!!(isUserAdmin || isAll) && (
                        <Typography
                          to={isPremiumPackage ? '/produtos' : location.pathname}
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            if(!isPremiumPackage) {
                              setMenuItemClicked('/produtos');
                              setIsTooltipModalOpen(true);
                            }

                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          {isPremiumPackage ? (
                            <>Listagem de produto</>
                          ) : (
                            <div style={{ display: 'flex', gap: 5 }}>
                              Listagem de produto
                              <Typography style={{ color: "#F5B941" }}>
                                <Star />
                              </Typography>
                            </div>
                          )}
                        </Typography>
                      )}
                      {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <>
                          <Typography className={classes.menuMobileSubTextTypography}>
                            <b>Relatórios ou Controle</b>
                          </Typography>
                          {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                            <Typography
                              to='/historico-de-venda'
                              component={Link}
                              className={classes.menuMobileTypography}
                              onClick={() => {
                                setMobileMenuOpen(!mobileMenuOpen);
                                setCurrentOpenMobileMenu(null);
                              }}
                            >
                              Histórico de Pedidos
                            </Typography>
                          )}
                        </>
                      )}
                      <Typography className={classes.menuMobileSubTextTypography}>
                        <b>Cadastro e Configuração</b>
                      </Typography>
                      {(isUserAdmin || isAll) && (
                        <Typography
                          to={isPremiumPackage ? handleProductButtonLink : location.pathname}
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            if(!isPremiumPackage) {
                              setMenuItemClicked(handleProductButtonLink());
                              setIsTooltipModalOpen(true);
                            }

                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          {isPremiumPackage ? (
                            <>Cadastrar produto</>
                          ) : (
                            <div style={{ display: 'flex', gap: 5 }}>
                              Cadastrar produto
                              <Typography style={{ color: "#F5B941" }}>
                                <Star />
                              </Typography>
                            </div>
                          )}
                        </Typography>
                      )}
                      {(isUserAdmin || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to='/marcas-de-produtos'
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          Marcas
                        </Typography>
                      )}
                      {(isUserAdmin || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to='/categorias-de-produtos'
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          Categorias
                        </Typography>
                      )}
                      <Typography
                        to={getSuppliersLink()}
                        component={Link}
                        className={classes.menuMobileTypography}
                        onClick={() => {
                          setMobileMenuOpen(!mobileMenuOpen);
                          setCurrentOpenMobileMenu(null);

                          if(!isPremiumPackage) {
                            if(isStoreOnly || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) {
                              return;
                            }

                            setMenuItemClicked('/fornecedores');
                            setIsTooltipModalOpen(true);
                          }
                        }}
                      >
                        {(isStoreOnly && !isPremiumPackage) ? (
                          <>Fornecedores</>
                        ) : (
                          <>
                            {(isPremiumPackage || isCarWashAndStoreBasic || isParkingAndStoreBasic || isParkingAndCarWashAndStoreBasic) ? (
                              <>Fornecedores</>
                            ) : (
                              <div style={{ display: 'flex', gap: 5 }}>
                                Fornecedores
                                <Typography style={{ color: "#F5B941" }}>
                                  <Star />
                                </Typography>
                              </div>
                            )}
                          </>
                        )}
                      </Typography>
                      {(isUserAdmin || isStoreBasicAndPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                        <Typography
                          to='/notas-fiscais'
                          component={Link}
                          className={classes.menuMobileTypography}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            setCurrentOpenMobileMenu(null);
                          }}
                        >
                          NFe e NFC
                        </Typography>
                      )}
                    </div>
                  </Collapse>
                </>
              )}
            </>
          )}
          {(isUserAdmin || (!isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.FINANCIAL))) && (
            <>
              <ListItem
                button
                className={(finantialMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                onClick={() => {
                  if(finantialMenuId.mobile == currentOpenMobileMenu) {
                    return setCurrentOpenMobileMenu(null);
                  }

                  setCurrentOpenMobileMenu(finantialMenuId.mobile);
                }}
                id={finantialMenuId.mobile}
              >
                <div className={classes.menuMobileText}>
                  <img src={Financial} width='20' height='20' />
                  <Typography color='primary' className={classes.menuMobileTextTypography}>
                    Financeiro
                  </Typography>
                </div>
                {(finantialMenuId.mobile == currentOpenMobileMenu) ? (
                  <ArrowDropUp style={{ color: '#022A5C' }} />
                ) : (
                  <ArrowDropDown style={{ color: '#022A5C' }} />
                )}
              </ListItem>
              <Collapse in={finantialMenuId.mobile == currentOpenMobileMenu}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Cadastro e/ou Listagem</b>
                  </Typography>
                  {!!(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/transacoes'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Transações
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/funcionarios' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/funcionarios');
                          setIsTooltipModalOpen(true);
                        }

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>Folha de pagamento</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          Folha de pagamento
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/comissionamento' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/comissionamento');
                          setIsTooltipModalOpen(true);
                        }

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>Comissionamento</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          Comissionamento
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Relatórios ou Controle</b>
                  </Typography>
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/fluxo-de-caixa'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Fluxo de caixa
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/notas-fiscais' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/notas-fiscais');
                          setIsTooltipModalOpen(true);
                        }

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>NFS-e</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          NFS-e
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                </div>
              </Collapse>
            </>
          )}
          {!!(isUserAdmin || (!isLoginFromNoAccessCode && (!userRestrictions?.includes(SITE_RESTRICTIONS.CLIENT) && !userRestrictions?.includes(SITE_RESTRICTIONS.CLIENTS)))) && (
            <>
              <ListItem
                button
                className={(clientsMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                onClick={() => {
                  if(clientsMenuId.mobile == currentOpenMobileMenu) {
                    return setCurrentOpenMobileMenu(null);
                  }

                  setCurrentOpenMobileMenu(clientsMenuId.mobile);
                }}
                id={clientsMenuId.mobile}
              >
                <div className={classes.menuMobileText}>
                  <img src={Clients} width='20' height='20' />
                  <Typography color='primary' className={classes.menuMobileTextTypography}>
                    Clientes
                  </Typography>
                </div>
                {(clientsMenuId.mobile == currentOpenMobileMenu) ? (
                  <ArrowDropUp style={{ color: '#022A5C' }} />
                ) : (
                  <ArrowDropDown style={{ color: '#022A5C' }} />
                )}
              </ListItem>
              <Collapse in={clientsMenuId.mobile == currentOpenMobileMenu}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Cadastro e Listagem</b>
                  </Typography>
                  {(isUserAdmin || isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/clientes'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Clientes
                    </Typography>
                  )}
                  {(isUserAdmin || isAll) && (
                    <Typography
                      to='/clientes?newClient=true'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Novo cliente
                    </Typography>
                  )}
                  {!!(isUserAdmin || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to='/lembrete-pos-venda'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Lembrete Pós Venda
                    </Typography>
                  )}
                  {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/agendamento' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/agendamento');
                          setIsTooltipModalOpen(true);
                        }

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>Agendamento</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          Agendamento
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                </div>
              </Collapse>
            </>
          )}
          {(isUserAdmin || (!isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.CONFIG))) && (
            <>
              <ListItem
                button
                className={(configurationsMenuId.mobile == currentOpenMobileMenu) ? classes.menuMobileItemNoBorder : classes.menuMobileItem}
                onClick={() => {
                  if(configurationsMenuId.mobile == currentOpenMobileMenu) {
                    return setCurrentOpenMobileMenu(null);
                  }

                  setCurrentOpenMobileMenu(configurationsMenuId.mobile);
                }}
                id={configurationsMenuId.mobile}
              >
                <div className={classes.menuMobileText}>
                  <img src={Settings} width='20' height='20' />
                  <Typography color='primary' className={classes.menuMobileTextTypography}>
                    Configurações
                  </Typography>
                </div>
                {(configurationsMenuId.mobile == currentOpenMobileMenu) ? (
                  <ArrowDropUp style={{ color: '#022A5C' }} />
                ) : (
                  <ArrowDropDown style={{ color: '#022A5C' }} />
                )}
              </ListItem>
              <Collapse in={configurationsMenuId.mobile == currentOpenMobileMenu}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 10, paddingLeft: 50 }}>
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Operacionais</b>
                  </Typography>
                  <Typography
                    to='/comprovantes'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Comprovantes
                  </Typography>
                  <Typography
                    to='/operacao'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Operação
                  </Typography>
                  <Typography
                    to='/caixa'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Caixa
                  </Typography>
                  {(isUserAdmin || (+profileId == 2 && +employeeMainUser == 1)) && (
                    <Typography
                      to='/configuracoes-avancadas'
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      Avançadas
                    </Typography>
                  )}
                  <Typography
                    to={isPremiumPackage ? '/api-aberta' : location.pathname}
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      if(!isPremiumPackage) {
                        setMenuItemClicked('/api-aberta');
                        setIsTooltipModalOpen(true);
                      }

                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    {isPremiumPackage ? (
                      <>API Aberta</>
                    ) : (
                      <div style={{ display: 'flex', gap: 5 }}>
                        API Aberta
                        <Typography style={{ color: "#F5B941" }}>
                          <Star />
                        </Typography>
                      </div>
                    )}
                  </Typography>
                  <Typography className={classes.menuMobileSubTextTypography}>
                    <b>Financeiras</b>
                  </Typography>
                  <Typography
                    to='/contas'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Contas
                  </Typography>
                  <Typography
                    to='/meios-de-pagamento'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Meios de pagamento
                  </Typography>
                  <Typography
                    to='/categorias'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Categorias
                  </Typography>
                  <Typography
                    to='/centros-de-custo'
                    component={Link}
                    className={classes.menuMobileTypography}
                    onClick={() => {
                      setMobileMenuOpen(!mobileMenuOpen);
                      setCurrentOpenMobileMenu(null);
                    }}
                  >
                    Centros de custo
                  </Typography>
                  {(isUserAdmin || isAll || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isParkingAndStoreBasic) && (
                    <Typography
                      to={isPremiumPackage ? '/configuracoes-de-notas-fiscais/informacoes-basicas' : location.pathname}
                      component={Link}
                      className={classes.menuMobileTypography}
                      onClick={() => {
                        if(!isPremiumPackage) {
                          setMenuItemClicked('/configuracoes-de-notas-fiscais/informacoes-basicas');
                          setIsTooltipModalOpen(true);
                        }

                        setMobileMenuOpen(!mobileMenuOpen);
                        setCurrentOpenMobileMenu(null);
                      }}
                    >
                      {isPremiumPackage ? (
                        <>NFS-e</>
                      ) : (
                        <div style={{ display: 'flex', gap: 5 }}>
                          NFS-e
                          <Typography style={{ color: "#F5B941" }}>
                            <Star />
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  )}
                </div>
              </Collapse>
            </>
          )}
          <ListItem
            button
            className={classes.menuMobileItem}
            id={profileMenuId.desktop}
            onClick={() => {
              setMobileMenuOpen(!mobileMenuOpen);
              setCurrentOpenMobileMenu(null);
              history.push('/perfil');
            }}
          >
            <div className={classes.menuMobileText}>
              <img src={Profile} width='20' height='20' />
              <Typography color='primary' className={classes.menuMobileTextTypography}>
                Perfil
              </Typography>
            </div>
          </ListItem>
        </List>
        <ListItem
          button
          className={classes.menuMobileLogoutItem}
          to="/"
          component={Link}
          onClick={logout}
        >
          <div className={classes.menuMobileText}>
            <img src={Logout} width='20' height='20' />
            <Typography color='primary' variant='h5'>
              Sair
            </Typography>
          </div>
        </ListItem>
      </Box>
    </Drawer>
  );

  return(
    <AppBar position="relative" elevation={0} className={classes.root}>
      {(isDebitWarningModalOpen && history.location.pathname != '/suas-assinaturas') && (
        <Modal
          id="isDebitWarningHeaderModal"
          title="Débito em Aberto"
          open={isDebitWarning && isDebitWarningModalOpen}
          onClose={() => setIsDebitWarningModalOpen(false)}
        >
          <Loader>
            <Typography>
              Estabelecimento(s) em aberto:
            </Typography>
            <br />
            {debitWarningEstablishments?.map(establishment => {
              return(
                <>
                  <Typography>{establishment?.establishmentId} - {establishment?.establishmentName}</Typography>
                </>
              );
            })}
            <CustomButton
              type="button"
              color="success"
              style={{ marginTop: 15 }}
              onClick={() => {
                if(debitWarningEstablishments?.length == 1) {
                  dispatch(setEstablishmentId({ establishmentId: debitWarningEstablishments[0]?.establishmentId || '' }));
                }

                history.push('/suas-assinaturas');
              }}
            >
              Suas Assinaturas
            </CustomButton>
          </Loader>
        </Modal>
      )}
      {isTooltipModalOpen && (
        <Modal
          id="tooltip-modal"
          title="Plano premium"
          open={isTooltipModalOpen}
          onClose={() => setIsTooltipModalOpen(false)}
        >
          <span>
            <Typography color="textSecondary" style={{ display: 'contents' }}>
              Assine o plano premium e obtenha acesso as funcionalidades que auxiliam você no dia-a-dia, agilize seus processos agora mesmo com o adicional de apenas
            </Typography>
            <Typography color="primary" style={{ display: 'contents' }}>
              <b> R$ 30,00 </b>
            </Typography>
            <Typography color="textSecondary" style={{ display: 'contents' }}>
              no plano mensal ou
            </Typography>
            <Typography color="primary" style={{ display: 'contents' }}>
              <b> R$ 20,00 </b>
            </Typography>
            <Typography color="textSecondary" style={{ display: 'contents' }}>
              mensal no plano anual.
            </Typography>
          </span>
          <Grid xs={12} style={{ marginTop: 10 }}>
            <iframe
              width='100%'
              height={(window.innerHeight / 2)}
              src={getPremiumPackageVideo()}
              frameBorder='0'
              allow='autoplay; encrypted-media'
              allowFullScreen
            />
          </Grid>
          <div style={{ borderBottom: '1px solid #E1E1E1', marginTop: 10 }} />
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
            <button style={{ height: 40, color: '#FFFFFF', backgroundColor: '#43A047', border: 'none', borderTopLeftRadius: 3, borderBottomLeftRadius: 3, padding: 5, cursor: 'pointer' }}>
              <WhatsApp />
            </button>
            <button
              onClick={handleSendMessage}
              style={{ height: 40, color: '#FFFFFF', backgroundColor: '#13BC4B', border: 'none', borderTopRightRadius: 3, borderBottomRightRadius: 3, padding: 5, cursor: 'pointer', textTransform: 'uppercase' }}
            >
              <b>Quero saber mais</b>
            </button>
          </div>
        </Modal>
      )}
      <Container maxWidth="lg" disableGutters className={classes.container}>
        <Toolbar>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.menuRow}
          >
            <Grid item>
              <Box to="/visao-geral" component={Link} className={classes.logo}>
                <img
                  style={{ marginTop: '10px' }}
                  src={isResale ? process.env.REACT_APP_RESALE_HEADER_LOGO : logo}
                  alt="Logo"
                  width="120"
                />
              </Box>
            </Grid>
            <Grid item className={classes.sectionDesktop}>
              {(isUserAdmin || !isLoginFromNoAccessCode) && (
                <Typography
                  to="/visao-geral"
                  variant="button"
                  color="inherit"
                  className={classes.menuItem}
                  component={Link}
                >
                  Visão Geral
                </Typography>
              )}
              {(isUserAdmin || (!isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.BUSINESS))) && (
                <Typography
                  variant="button"
                  color="inherit"
                  className={classes.menuItem}
                  onClick={handleOpenMenu}
                  id={businessMenuId.desktop}
                >
                  Negócio
                  <ExpandMore />
                </Typography>
              )}
              {(isUserAdmin || !isLoginFromNoAccessCode) && (
                <>
                  {(isAll || isParkingBasic || isParkingPremium || isCarWashBasic || isCarWashPremium || isParkingAndCarWashBasic || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      variant="button"
                      color="inherit"
                      className={classes.menuItem}
                      onClick={handleOpenMenu}
                      id={operationalMenuId.desktop}
                    >
                      {(isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndCarWashAndStoreBasic) ? 'Serviços' : 'Operacional'}
                      <ExpandMore />
                    </Typography>
                  )}
                </>
              )}
              {(isUserAdmin || !isLoginFromNoAccessCode) && (
                <>
                  {(isAll || isCarWashPremium || isStoreBasicAndPremium || isParkingAndCarWashPremium || isCarWashAndStoreBasic || isCarWashAndStorePremium || isParkingAndStoreBasic || isParkingAndStorePremium || isParkingAndCarWashAndStoreBasic) && (
                    <Typography
                      variant="button"
                      color="inherit"
                      className={classes.menuItem}
                      onClick={handleOpenMenu}
                      id={productsMenuId.desktop}
                    >
                      Produtos
                      <ExpandMore />
                    </Typography>
                  )}
                </>
              )}
              {(isUserAdmin || (!isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.FINANCIAL))) && (
                <Typography
                  variant="button"
                  color="inherit"
                  className={classes.menuItem}
                  onClick={handleOpenMenu}
                  id={finantialMenuId.desktop}
                >
                  Financeiro
                  <ExpandMore />
                </Typography>
              )}
              {(isUserAdmin || (!isLoginFromNoAccessCode && (!userRestrictions?.includes(SITE_RESTRICTIONS.CLIENT) && !userRestrictions?.includes(SITE_RESTRICTIONS.CLIENTS)))) && (
                <Typography
                  variant="button"
                  color="inherit"
                  className={classes.menuItem}
                  onClick={handleOpenMenu}
                  id={clientsMenuId.desktop}
                >
                  Clientes
                  <ExpandMore />
                </Typography>
              )}
            </Grid>
            <Grid item className={classes.sectionDesktop}>
              {(isUserAdmin || (!isLoginFromNoAccessCode && !userRestrictions?.includes(SITE_RESTRICTIONS.CONFIG))) && (
                <Button
                  id={configurationsMenuId.desktop}
                  edge="end"
                  aria-label="Configurações do sistema"
                  aria-controls={businessMenuId}
                  aria-haspopup="true"
                  onClick={handleOpenMenu}
                  color="inherit"
                  startIcon={<SettingsIcon />}
                />
              )}
              <Button
                id={profileMenuId.desktop}
                edge="end"
                aria-label="Configurações de perfil"
                aria-controls={businessMenuId}
                aria-haspopup="true"
                onClick={handleOpenMenu}
                color="inherit"
                startIcon={<Person />}
              />
            </Grid>
            <Grid item className={classes.sectionMobile}>
              <IconButton
                aria-label="Mostrar menu em smarthphones"
                aria-controls={businessMenuId.mobile}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              {/* Mobile menu */}
              {renderMobileMenu}
            </Grid>
            {/* Desktop menu lists */}
            {renderBusinessMenu}
            {renderOperacionalMenu}
            {renderProductsMenu}
            {renderFinantialMenu}
            {renderClientsMenu}
            {renderConfigurationMenu}
            {renderProfileMenu}
          </Grid>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;